import { TranslateService } from '@ngx-translate/core';
import * as Domain from '@core/Domain';

export class DomainIit {

  static Init(translateService: TranslateService) {
const domain_LocalResourcesDefinition = new Domain.Domain_LocalResourcesDefinition(translateService);
const globalResourcesDefinition = new Domain.GlobalResourcesDefinition(translateService);
const subscription = new Domain.Subscription(translateService);
const application = new Domain.Application(translateService);
const aPIKey = new Domain.APIKey(translateService);
const mCPServer = new Domain.MCPServer(translateService);
const databaseConnectionInfo = new Domain.DatabaseConnectionInfo(translateService);
const subscriptionAccess = new Domain.SubscriptionAccess(translateService);
const lLMOption = new Domain.LLMOption(translateService);
const databaseType = new Domain.DatabaseType(translateService);
const paymentEntry = new Domain.PaymentEntry(translateService);
const billingDetails = new Domain.BillingDetails(translateService);
const usageEntry = new Domain.UsageEntry(translateService);
const pricelist = new Domain.Pricelist(translateService);
const usageEntryItem = new Domain.UsageEntryItem(translateService);
const userAccount = new Domain.UserAccount(translateService);
const createAccountDTO = new Domain.CreateAccountDTO(translateService);
const applicationDTO = new Domain.ApplicationDTO(translateService);
const subscriptionDTO = new Domain.SubscriptionDTO(translateService);
const startRequestInfo = new Domain.StartRequestInfo(translateService);
const mCPServerDTO = new Domain.MCPServerDTO(translateService);
const aPIKeyDTO = new Domain.APIKeyDTO(translateService);
const billingDetailsDTO = new Domain.BillingDetailsDTO(translateService);
const addBalanceDTO = new Domain.AddBalanceDTO(translateService);
const serviceUsageInfoDTO = new Domain.ServiceUsageInfoDTO(translateService);
const applicationUserAction = new Domain.ApplicationUserAction(translateService);
const applicationUserExternalProfile = new Domain.ApplicationUserExternalProfile(translateService);
const applicationSetting = new Domain.ApplicationSetting(translateService);
const applicationUser = new Domain.ApplicationUser(translateService);
const applicationRole = new Domain.ApplicationRole(translateService);
const applicationOperation = new Domain.ApplicationOperation(translateService);
const applicationPermission = new Domain.ApplicationPermission(translateService);
const applicationClient = new Domain.ApplicationClient(translateService);
const applicationUserLogin = new Domain.ApplicationUserLogin(translateService);
const applicationUserClaim = new Domain.ApplicationUserClaim(translateService);
const profileSetting = new Domain.ProfileSetting(translateService);
const profile = new Domain.Profile(translateService);
const applicationLanguage = new Domain.ApplicationLanguage(translateService);
const applicationTimezoneInfo = new Domain.ApplicationTimezoneInfo(translateService);
const dateTimeFormat = new Domain.DateTimeFormat(translateService);
const applicationTheme = new Domain.ApplicationTheme(translateService);
const fileData = new Domain.FileData(translateService);
const auditEntityConfiguration = new Domain.AuditEntityConfiguration(translateService);
const auditPropertyConfiguration = new Domain.AuditPropertyConfiguration(translateService);
const auditLogEntry = new Domain.AuditLogEntry(translateService);
const auditLogEntryType = new Domain.AuditLogEntryType(translateService);
const auditLogPropertyActionType = new Domain.AuditLogPropertyActionType(translateService);
const workflowExecutionResult = new Domain.WorkflowExecutionResult(translateService);
const workflowContextBase = new Domain.WorkflowContextBase(translateService);
const workflowSchedule = new Domain.WorkflowSchedule(translateService);
const usageEntryHandlerContext = new Domain.UsageEntryHandlerContext(translateService);
 }

}
